import { render, staticRenderFns } from "./EditInvestment.vue?vue&type=template&id=ce13996a&"
import script from "./EditInvestment.vue?vue&type=script&lang=js&"
export * from "./EditInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports